import { render, staticRenderFns } from "./media-card.vue?vue&type=template&id=22c58a82&scoped=true&"
import script from "./media-card.ts?vue&type=script&lang=ts&"
export * from "./media-card.ts?vue&type=script&lang=ts&"
import style0 from "./media-card.scss?vue&type=style&index=0&id=22c58a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c58a82",
  null
  
)

export default component.exports